// extracted by mini-css-extract-plugin
module.exports = {"Zoom":"VideoCall_Zoom__3z7Fb","Description":"VideoCall_Description__3IrZ3","meetingSDKElement":"VideoCall_meetingSDKElement__26PdA","MuiBox-root":"VideoCall_MuiBox-root__3DrtD"};